import axios, { AxiosError } from 'axios';

import { reactRichComponentsConfig, ServiceType } from './react-rich-components-config';

export class HttpResolver {
  private refreshTried = false;

  constructor(private serviceType: ServiceType) {}

  resolve(basePath?: string) {
    const axiosInstance = axios.create({
      timeout: 30000,
      baseURL: reactRichComponentsConfig.serviceUrls[this.serviceType] + (basePath ?? ''),
    });

    axiosInstance.interceptors.request.use(async (config) => {
      const tokenResolver = reactRichComponentsConfig.tokenResolver;

      if (tokenResolver) {
        config.headers.Authorization = `Bearer ${await tokenResolver.getAccessToken()}`;
      }

      config.headers['X-CSRF-Token'] = this.getCookie('csrf_token');

      return config;
    });

    axiosInstance.interceptors.response.use(
      (response) => {
        this.refreshTried = false;

        return response;
      },
      async (error: AxiosError) => {
        const tokenResolver = reactRichComponentsConfig.tokenResolver;

        if (tokenResolver && error.config && error.response?.status === 401 && !this.refreshTried) {
          const refreshedToken = await tokenResolver.refreshAccessToken();

          if (refreshedToken) {
            error.config.headers.Authorization = `Bearer ${refreshedToken}`;
            this.refreshTried = true;

            return axios.request(error.config);
          }
        }

        throw error;
      },
    );

    return axiosInstance;
  }

  private getCookie(name: string): string | null {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop()?.split(';').shift() || null;
    return null;
  }
}
